import classes from "../../css/modules/navigation.module.scss";
import { MenuItems } from "./MenuItems";
import { LocaleSelect } from "./LocaleSelect";
import { CleanCache } from "./MenuItems/components/CleanCache";
import React from "react";
import { AppVersion } from "../AppVersion";

export function MenuContent({ onLocationChange }) {
  return (
    <div className={classes.menuContent} data-testid="mn_menu_sidebar">
      <MenuItems onLocationChange={onLocationChange} />
      <div className={classes.btnWrapper}>
        <LocaleSelect />
        <CleanCache />
        <AppVersion />
      </div>
    </div>
  );
}
